import { PersonAdd } from '@mui/icons-material';
import { Button, Stack, type StackProps, Typography } from '@mui/material';
import { type ReactNode, useState } from 'react';
import { _ } from '/@/locale';
import { mpTrackEvent } from '/@/store/tracking/mixpanel-events';
import NewGrowersModalV2 from '../../../growers/components/new-growers-modal-v2';

const CreateGrowerSection = ({
    onAddFields,
    onOpenModal,
    onButtonClick,
    title = _('Agregá a los primeros productores'),
    subtitle = _('Vas a poder hacer un seguimiento de sus lotes y generar recomendaciones personalizadas.'),
    buttonLabel = _('Agregar productor'),
    icon,
    sx,
    singleGrower = false,
    hideButton = false,
}: {
    onAddFields: (growerUserNodeId?: number) => void;
    onOpenModal?: () => void;
    onButtonClick?: () => void;
    title?: string;
    subtitle?: string;
    buttonLabel?: string;
    icon?: ReactNode;
    sx?: StackProps['sx'];
    singleGrower?: boolean;
    hideButton?: boolean;
}) => {
    const [newGrowersModalOpen, setNewGrowersModalOpen] = useState(false);
    const usesExternalModal = !!onOpenModal;

    const handleClickNewGrower = () => {
        if (onButtonClick) {
            onButtonClick();
            return;
        }
        mpTrackEvent('Grower Creation flow:Started', {});
        if (usesExternalModal) {
            onOpenModal();
        } else {
            setNewGrowersModalOpen(true);
        }
    };

    return (
        <Stack
            alignItems='center'
            justifyContent='center'
            px={2}
            py={4}
            backgroundColor='#F5F5F5'
            height='100%'
            sx={sx}
        >
            {icon ?? <PersonAdd sx={{ width: 36, height: 36, mb: 1 }} color='primary' />}
            <Stack mb={hideButton ? 0 : 3} textAlign='center'>
                <Typography variant='subtitle1' fontWeight='bold' color='primary'>
                    {title}
                </Typography>
                {subtitle ? (
                    <Typography variant='subtitle1' color='primary.mui.inactive'>
                        {subtitle}
                    </Typography>
                ) : null}
            </Stack>
            {!hideButton && (
                <Button variant='contained' color='secondary' onClick={handleClickNewGrower}>
                    {buttonLabel}
                </Button>
            )}
            {!usesExternalModal && !onButtonClick && (
                <NewGrowersModalV2
                    open={newGrowersModalOpen}
                    setOpen={setNewGrowersModalOpen}
                    onAddFields={onAddFields}
                    singleGrower={singleGrower}
                />
            )}
        </Stack>
    );
};

export default CreateGrowerSection;
